import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { IconVariant } from "@/types";
import { LARGE_NODE_LAYOUT_COUNT } from "@/util";
import {
  artifactStore,
  cyStore,
  layoutApiStore,
  layoutStore,
  permissionStore,
} from "@/hooks";
import { IconButton, FlexBox } from "@/components/common";
import VisibleTypeButtons from "./VisibleTypeButtons.vue";


/**
 * Renders buttons for changing the graph view.
 */
const __default__ = {
  name: "GraphButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const viewButtons = computed(() => [
  {
    handler: () => cyStore.zoom("in"),
    label: "Zoom In",
    icon: "graph-zoom-in" as IconVariant,
    disabled: layoutStore.isTableMode,
    dataCy: "button-nav-graph-zoom-in",
  },
  {
    handler: () => cyStore.zoom("out"),
    label: "Zoom Out",
    icon: "graph-zoom-out" as IconVariant,
    disabled: layoutStore.isTableMode,
    dataCy: "button-nav-graph-zoom-out",
  },
  {
    handler: () => cyStore.centerNodes(true),
    label: "Center Graph",
    icon: "graph-center" as IconVariant,
    disabled: layoutStore.isTableMode,
    dataCy: "button-nav-graph-center",
  },
  {
    handler: () => {
      if (
        layoutStore.isTreeMode &&
        artifactStore.currentArtifacts.length > LARGE_NODE_LAYOUT_COUNT
      ) {
        layoutApiStore.handleRegenerate();
      } else {
        layoutStore.setGraphLayout("project", true);
      }
    },
    label: "Regenerate Layout",
    icon: "graph-refresh" as IconVariant,
    disabled:
      layoutStore.isTableMode ||
      !permissionStore.isAllowed("project.edit_data"),
    dataCy: "button-nav-graph-refresh",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_unref(layoutStore).isTimMode || _unref(layoutStore).isTreeMode)
    ? (_openBlock(), _createBlock(_component_q_page_sticky, {
        key: 0,
        position: "top-right",
        class: "artifact-fab"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            column: "",
            x: "2",
            y: "2",
            align: "end",
            style: {"width":"40px"}
          }, {
            default: _withCtx(() => [
              _createVNode(VisibleTypeButtons),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewButtons.value, (definition) => {
                return (_openBlock(), _createBlock(_unref(IconButton), {
                  key: definition.label,
                  color: "text",
                  tooltip: definition.label,
                  icon: definition.icon,
                  disabled: definition.disabled,
                  "data-cy": definition.dataCy,
                  onClick: definition.handler
                }, null, 8, ["tooltip", "icon", "disabled", "data-cy", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})